<template>
  <ItemDialog ref="DialogBookInDirectRefundComplete" imageType="done">
    <template v-slot:content-area>
      <h2>払い戻し申請受付完了</h2>
      <br />
      <div style="font-size: 16px"
        >払い戻し申請を受け付けました。
        <br />払い戻し処理には少々お時間を頂きます。
        <br />返金までいましばらくお待ちください。</div
      >
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="OK"
        actionType="btn-primary"
        @clicked="returnNativeAppMyticketPage"
      />
    </template>
  </ItemDialog>
</template>

<script>
export default {
  name: "DialogBookInDirectRefundComplete",
  methods: {
    async openDialog() {
      this.$refs.DialogBookInDirectRefundComplete.open();
    },
    async closeDialog() {
      this.$refs.DialogBookInDirectRefundComplete.close();
    },
  },
};
</script>
